import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "../../shared/translate/translate.service";
import {
  ApplicationRouteURL,
  DataListModel,
  WeGoConfig,
  IKeyValueInterface,
  PermissionType,
  RoleLevel
} from "../../shared/config";
import { AuthService } from "../../shared/models/auth.service";
import { InstanceService } from "../../instance/models/instance.service";
import { PersonModel } from "../../person/models/person.model";
import { InstanceModel } from "../../instance/models/instance.model";
import { ActivatedRoute } from "@angular/router";
import { FileUploader } from "ng2-file-upload";
import { SignupService } from "../../signup/models/signup.service";
import {
  BatchUploadPersonModel,
  SVGModel
} from "../model/batch-upload-person.model";
import { OrganizationService } from "../../organization/models/organization.service";
import { DropdownModel } from "../../report/models/report-filter.model";

@Component({
  selector: "wego-batch-upload-person",
  providers: [SignupService, InstanceService, OrganizationService],
  template: require('../views/batch-upload-person.component.html'),
  styles: [
    `
    .setmargin
    {
        margin-top:10px;
    }
    .error-td
    {
      word-wrap: break-word;
      word-break: break-word;
      max-width: 300px;
    }
    `
  ]
})
export class BatchUploadPersonComponent implements OnInit {
  isParentCheck: boolean;
  public listOfFilterRecord: any[];
  batchUploadPersonModel: BatchUploadPersonModel;
  private popupMsg: string;
  DataListModel: DataListModel;
  public uploader: FileUploader;
  public headers: any;
  isLoading: boolean;
  apiErrorMsg: string;
  model: PersonModel;
  urlDefaultPage: string;
  urlPersonList: string;
  urlDriverList: string;
  breadCrumbList: string;
  module: string;
  instanceList: any;
  errorMessage: string;
  instanceHashId: string = "";
  instanceModel: InstanceModel;
  sub: any;
  importDriverRole: boolean = false;
  public csvValidationMsg: string;
  public listOfRecord: any[];
  importUserAssigedToSVG: boolean = true;
  sVGModelList: SVGModel[];
  isInit: boolean = false;
  organizationList: DropdownModel[];
  organizationMasterHashId: string = "";
  isMultipleOrganization: boolean = false;
  errorModel: IKeyValueInterface[];
  pageName: string;
  roleLevel = RoleLevel;

  @ViewChild("assignToSVGModal") public assignToSVGModal: any;
  @ViewChild("csvFile") public csvFile: any;
  @ViewChild("successPopup") public successPopup: any;

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private instanceService: InstanceService,
    private organizationService: OrganizationService,
    private activeRoute: ActivatedRoute,
    private signupService: SignupService
  ) { }

  ngOnInit() {
    this.InitBatchUpload();
  }

  public InitBatchUpload() {
    this.pageName = "BatchUploadPerson";
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlPersonList = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_LIST
    );
    this.urlDriverList = this.authService.GetURL(
      ApplicationRouteURL.URL_DRIVER_LIST
    );
    this.batchUploadPersonModel = new BatchUploadPersonModel();
    
    this.importDriverRole = true;
    
    this.module = this.translate.instant("LblPerson");
    
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
    this.ResetPaging();
    this.headers = this.authService.GetHeaderForFile();
    this.uploader = new FileUploader({
      url: WeGoConfig.API_VALIDATE_BATCH_UPLOAD_PERSON_CSV,
      headers: this.headers
    });
    this.uploader.onAfterAddingFile = (fileItem: any) =>
      this.HandleOnAfterAddingFile(fileItem);
    this.uploader.onBuildItemForm = (fileItem: any, Form: any) =>
      this.HandleOnBuildItemForm(fileItem, Form);
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => this.HandleOnCompleteItem(item, response, status, headers);
    this.instanceModel = new InstanceModel();
    this.GetInstanceList();
    //this.GetOrganizationList();

    this.isInit = true;
  }

  public GetInstanceList() {
    this.instanceService.GetInstanceForBatchUpload().subscribe(
      res => {
        this.instanceList = (res.data as any[]).sort(function(a, b) {
          var textA = a.instanceName.toUpperCase();
          var textB = b.instanceName.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });;

        if (this.instanceList && this.instanceList.length > 0) {
          if (!this.instanceHashId && this.instanceList.length == 1) {
            this.instanceHashId = this.instanceList[0].instanceHashId;
            this.GetOrganizationList();
          }
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  // public GetOrganizationList() {
  //   this.organizationService.GetOrganizationForBatchUpload()
  //     .subscribe(
  //     res => {
  //       this.organizationList = res.data;
  //       this.isMultipleOrganization = true;
  //       if (this.organizationList.length == 1) {
  //         this.isMultipleOrganization = false;
  //         this.organizationMasterHashId = this.organizationList[0].organizationMasterHashId;
  //       }
  //     },
  //     error => {
  //       this.errorMessage = this.authService.HandleErrorStatusCode(error);
  //     });
  // }

  public HandleOnAfterAddingFile(fileItem: any) {
    if (this.uploader.queue.length > 1) {
      this.uploader.queue.forEach(element => {
        element.remove();
      });
    }
  }
  public FilterList() {
    let start =
      this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
    let end = start + this.DataListModel.itemsPerPage;
    this.listOfFilterRecord = this.listOfRecord.slice(start, end);
  }
  public HandleOnCompleteItem(
    item: any,
    response: any,
    status: any,
    headers: any
  ) {
    //For successful result  method simply return error
    //For Failed result error code will be handled in following
    this.authService.HandleErrorStatusCode(status);
    /////

    this.ResetPaging();
    let apiresponse: any = JSON.parse(response);
    if (status == 200) {
      if (!apiresponse.error) {
        this.csvValidationMsg = "";
        this.listOfRecord = apiresponse.data;
        this.DataListModel.totalItems = apiresponse.totalRecords;
        this.FilterList();
      } else {
        this.csvValidationMsg = apiresponse.error;
        this.listOfRecord = [];
      }
    }
    this.isLoading = false;
    this.ClearFileInput();
  }

  public OnInstanceTypeChange() {
    this.sub = this.activeRoute.params.subscribe(params => {
      if (this.instanceHashId) {
        this.instanceService
          .GetBatchUploadDetailByHashId(this.instanceHashId)
          .subscribe(
          res => {
            this.instanceModel = res.data;
            this.GetOrganizationList();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
          );
      }
    });
  }

  public GetOrganizationList() {
    this.organizationService
      .GetOrganizationListDropdownForAddUpdatePage(
      this.pageName,
      PermissionType.INSERT,
      this.instanceHashId
      )
      .subscribe(
      res => {
        this.organizationList = res.data;
        this.organizationMasterHashId = "";
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
      );
  }

  public HandleOnBuildItemForm(fileItem: any, Form: any) {
    Form.append("instanceHashId", this.instanceHashId);
  }

  public ShowAssignToSVGModal() {
    this.assignToSVGModal.instanceHashId = this.instanceHashId;
    this.assignToSVGModal.organizationMasterHashId = this.organizationMasterHashId;
    this.assignToSVGModal.sVGModel = this.sVGModelList;
    this.assignToSVGModal.show();
  }

  public SuccessAssignToSVGModal($event: any) {
    this.sVGModelList = $event.SVGModel;
    this.batchUploadPersonModel.sVGModel = $event.SVGModel;
    this.importUserAssigedToSVG = $event.SVGModel.length > 0 ? false : true;
  }

  get ValidFormData() {
    if (this.uploader.queue.length > 0 && this.instanceHashId != "")
      return true;
    else return false;
  }

  public ValidateCSV() {
    this.isLoading = true;
    this.uploader.uploadAll();
  }

  public ImportCSV() {
    this.isLoading = true;
    this.ImportPersonRecord();
  }

  public ImportPersonRecord() {
    let validPersonList = this.listOfRecord.filter(x => x.isValidRecord);
    this.batchUploadPersonModel.signupModel = validPersonList;
    this.batchUploadPersonModel.assignToDriver = this.importDriverRole;
    this.batchUploadPersonModel.organizationMasterHashId = this.organizationMasterHashId;
    this.signupService
      .ImportPersonRecord(this.batchUploadPersonModel)
      .subscribe(
      res => {
        if (res.data) {
          let module = this.translate.instant("LblPerson");
          this.popupMsg = this.translate.instant("LblRecordImportedSuccess", [
            module
          ]);

          this.ShowSuccessPopup();

          this.listOfRecord = [];
          this.errorModel = [];
          this.instanceHashId = "";
          this.instanceModel = new InstanceModel();
          this.importDriverRole = false;
          this.importUserAssigedToSVG = true;
          this.ResetPaging();
          this.batchUploadPersonModel = new BatchUploadPersonModel();
          this.organizationMasterHashId = "";
          this.organizationList = [];          
          this.OnInstanceTypeChange();          
          this.ClearSVGs();          
        } else {
          if (res.error instanceof Array) {
            this.errorModel = res.error;
          } else {
            this.csvValidationMsg = res.error;
          }
        }
        this.isLoading = false;
      },
      error => {
        this.csvValidationMsg = this.authService.HandleErrorStatusCode(error);
        this.listOfRecord = [];
        this.instanceHashId = "";
        this.isLoading = false;
        this.instanceModel = new InstanceModel();
        this.importDriverRole = false;
        this.importUserAssigedToSVG = true;
        this.ResetPaging();
        this.ClearSVGs();
        this.batchUploadPersonModel = new BatchUploadPersonModel();
        this.organizationMasterHashId = "";

        this.GetOrganizationList();
      }
      );
  }

  get ValidImportRecord() {
    if (
      this.listOfRecord &&
      this.listOfRecord.length > 0 &&
      this.listOfRecord.filter(x => x.isValidRecord).length > 0
    )
      return true;
    else return false;
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.FilterList();
  }
  public DownloadTemplate() {
    let url = "/csv_templates/Batch_Upload_Format_WeGo.csv";
    window.location.href = url;
  }

  public ClearSVGs() {
    this.sVGModelList = null;
    this.batchUploadPersonModel.sVGModel = new Array<SVGModel>();
  }

  public ClearFileInput() {
    if (this.csvFile.nativeElement) {
      this.csvFile.nativeElement.value = "";
      this.uploader.clearQueue();
    }
  }

  public ResetPaging() {
    this.DataListModel = new DataListModel();
    this.DataListModel.itemsPerPage = 100;
  }
  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/batchuploadperson/component/batch-upload-person.component.ts